import { render, staticRenderFns } from "./sso-type-setup.vue?vue&type=template&id=523bb849&scoped=true&"
import script from "./sso-type-setup.ts?vue&type=script&lang=ts&"
export * from "./sso-type-setup.ts?vue&type=script&lang=ts&"
import style0 from "./sso-type-setup.scss?vue&type=style&index=0&id=523bb849&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bb849",
  null
  
)

export default component.exports